import React, { createContext, useContext, useState, ReactNode } from 'react';  
import { PageLoader } from '../components/ui/loader'; // Assuming PageLoader is your loading component.  

interface LoadingContextType {  
  isLoading: boolean;  
  setIsLoading: (isLoading: boolean) => void;  
}  

// Create the context with a default value of undefined  
const LoadingContext = createContext<LoadingContextType | undefined>(undefined);  

export const LoadingProvider: React.FC<{ children: ReactNode }> = ({ children }) => {  
    const [isLoading, setIsLoading] = useState(false);  

    return (  
        <LoadingContext.Provider value={{ isLoading, setIsLoading }}>  
            {/* Show the PageLoader if loading state is true */}  
            {isLoading && <PageLoader />}  
            {children}  
        </LoadingContext.Provider>  
    );  
};   

export const useLoading = () => {  
  const context = useContext(LoadingContext);  
  if (context === undefined) {  
    throw new Error('useLoading must be used within a LoadingProvider');  
  }  
  return context;  
}  